// extracted by mini-css-extract-plugin
export default {"master_filter":"HistoryFilters_master_filter__3j89K"};